let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("56AJD")).then(() => parcelRequire('b1TUx'));